import { Component } from '@angular/core';
import { NavigationService } from 'src/app/___LOGIC/__navigation/navigation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {

  constructor(private navigationService: NavigationService) { }

  ngOnInit(): void {
  }

  goToPage(element){
   this.navigationService.navigateTo(element.page);
  }
  
  getCurrentCss(element){
    this.navigationService.isPageActive(element.page)? element.class = 'nav-item active' : element.class = 'nav-item' ;
    return element.class;
  }

  getCurrentButtons(){
    return this.navigationService.getFooterButtonMenuItems();
  }

  downloadPdf(): void {
    // Call service to download
    /* let pdfUrl = this.pdfManager.getPdfToDownload(this.pdfManager.getCurrentPdfId());
    const pdfName = this.pdfManager.getPdfName(this.pdfManager.getCurrentPdfId());
    this.pdfManager.downloadPDF(pdfUrl, pdfName); */
  }

  downloadPdf2(url){
    //window.open('../../../assets/voyjaleas/pdf/empadronamiento/hojaPadronal.pdf', '_blank');
    /* var link = document.createElement('a');
    link.href = 'assets/voyjaleas/pdf/empadronamiento/hojaPadronal.pdf';
    link.download = 'file.pdf';
    link.dispatchEvent(new MouseEvent('click')); */
  }
}
